import { Inject, Injectable, InjectionToken } from "@angular/core";
import { Observable } from "rxjs/Observable";

export const LOCALSTORAGE = new InjectionToken("localStorage");

@Injectable()
export class TokenStorage {
  constructor(@Inject(LOCALSTORAGE) private localStorage: any) {}

  /**
   * Get access token
   * @returns {Observable<string>}
   */
  public getAccessToken(): Observable<string> {
    const token: string = <string>this.localStorage.getItem("accessToken");
    return Observable.of(token);
  }

  /**
   * Get refresh token
   * @returns {Observable<string>}
   */
  public getRefreshToken(): Observable<string> {
    const token: string = <string>this.localStorage.getItem("refreshToken");
    return Observable.of(token);
  }

  /**
   * Set access token
   * @returns {TokenStorage}
   */
  public setAccessToken(token: string): TokenStorage {
    this.localStorage.setItem("accessToken", token);

    return this;
  }

  /**
   * Set refresh token
   * @returns {TokenStorage}
   */
  public setRefreshToken(token: string): TokenStorage {
    this.localStorage.setItem("refreshToken", token);

    return this;
  }

  /**
   * Remove tokens
   */
  public clear() {
    this.localStorage.removeItem("accessToken");
    this.localStorage.removeItem("refreshToken");
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/services/token-storage.service.ts